export const routes = {
	HOME: "/",
	LOGIN: "/login",
	ACTIVATE: "/activate",
	FORGOT_PASSWORD: "/forgot-password",
	RESET_PASSWORD: "/password-reset/:token",

	SCHEDULE: "/overview",

	JOBS: "/jobs",
	JOB_DETAILS: "/jobs/:jobId",
	JOB_OVERVIEW: "overview",
	JOB_CONSULTANT: "consultants",
	JOB_SCHEDULE: "schedule",
	JOB_HISTORY: "history",
	JOB_CREATE: "/jobs/new",

	TIME_REPORTS: "/time-reports",
	TIME_REPORTS_THIS_MONTH: "/time-reports?period=month",

	DOCUMENTS: "/documents",
	DOCUMENT_UPLOAD: "/documents/uploadFile",
	DOCUMENT_EDIT: "/documents/edit/:documentId",
	DOCUMENT_EDIT_LINK: "/documents/editLink/:documentId",
	LINK_UPLOAD: "/documents/addLink",

	CONSULTANTS: "/consultants",
	CONSULTANTS_DETAILS: "/consultants/:consultantId",
	CONSULTANTS_PROFILE: "profile",
	CONSULTANTS_COMPETENCE: "competence",
	CONSULTANTS_EMPLOYMENT_AND_SALARY: "employment-and-salary",
	CONSULTANTS_DOCUMENTS: "documents",
	CONSULTANTS_AVAILABILITY: "availability",
	CONSULTANTS_SALARY_VIEW: "salary-view",
	CONSULTANTS_HISTORY: "history",
	CONSULTANTS_CUSTOMER_BLOCK: "customer-block",
	CONSULTANTS_ABSENCE: "absence",
	CONSULTANTS_SHIFTS: "jobs",

	CONSULTANTS_NEW: "/consultants/create",

	CUSTOMERS: "/customers",
	CUSTOMER_DETAILS: "/customers/:customerId",
	CUSTOMER_PROFILE: "profile",
	CUSTOMER_JOBS: "jobs",
	CUSTOMER_INVOICE_DETAILS: "invoice-details",
	CUSTOMER_USERS: "users",
	CUSTOMER_HISTORY: "history",
	CUSTOMER_CONTRACT: "contract-and-prices",
	CUSTOMER_CREATE: "/customers/new",
	// Koncern (corporate-group) admin. The page/tab is provided by the
	// corporate-groups feature (PR #564); this constant lets the customers list's
	// overflow menu link to it ahead of that integration.
	CUSTOMER_CORPORATE_GROUPS: "/customers/corporate-groups",
	// List of all customer accounts (kundanvändare) for the authed organisation,
	// reached from the customers list's overflow menu.
	CUSTOMER_USERS_LIST: "/customers/users",
	CUSTOMER_USER_CREATE: "/customers/:customerId/users/new",
	CUSTOMER_USER_EDIT: "/customers/:customerId/users/:userId",

	CONTRACTS: "/contracts",
	AGREEMENT: "/agreements",
	CREATE_AGREEMENT: "/agreements/new",
	EDIT_AGREEMENT: "/agreements/:id",
	CONTRACTS_CREATE: "/contracts/new",
	CONTRACT_DETAILS: "/contracts/:contractId",
	CONTRACT_INFO: "contract",
	CONTRACT_TERMS: "contract-terms",
	OB: "ob",

	RECRUITMENT: "/recruitment",
	RECRUITMENT_DETAILS: "/recruitment/:candidateId",
	RECRUITMENT_PROFILE: "profile",
	RECRUITMENT_DOCUMENTS: "documents",
	RECRUITMENT_COMPETENCE: "competence",
	RECRUITMENT_HISTORY: "history",
	// The consultant event timeline. Separate from RECRUITMENT_HISTORY, which is
	// the recruitment-pipeline log (status changes, messages, contract).
	RECRUITMENT_EVENTS: "events",
	RECRUITMENT_PRESENTATION: "public-presentation",
	RECRUITMENT_EMPLOYMENT_AND_SALARY: "employment-and-salary",
	RECRUITMENT_CREATE: "/recruitment/new",

	JOB_REPORTS: "/job-reports",
	JOB_REPORT_DETAILS: "/job-reports/:jobReportId",

	INVOICES: "/invoices",
	INVOICE_DETAILS: "/invoices/:invoiceId",

	INVOICE_BATCHES: "/invoice-batches",
	INVOICE_BATCH_DETAILS: "/invoice-batches/:id",
	INVOICE_BATCH_CREATE: "/invoice-batch/new",
	INVOICE_JOURNAL: "/invoice-batches/journal/:id",

	SALARY: "/salary",
	SALARY_NEW_BATCH: "/salary/new-batch",
	SALARY_BATCH_DETAILS: "/salary/:salaryBatchId",
	SALARY_JOURNAL: "/salary/salary-journal/:salaryBatchId",

	INTERNAL_USERS: "/internal-users",
	INTERNAL_USER_PROFILE: "/internal-users/:userId",
	INTERNAL_USERS_INVITE: "/internal-users/invite-user",

	CUSTOMERS_REPORT: "/reports/customers",
	CUSTOMER_CONTACTS_REPORT: "/reports/customer-contacts",
	CONSULTANTS_REPORT: "/reports/consultants",
	CANDIDATES_REPORT: "/reports/candidates",
	CONSULTANTS_WORKED_HOURS_REPORT: "/reports/consultants-hours",
	SOLD_HOURS_AND_REVENUE_REPORT: "/reports/sales-revenue",
	FEEDBACK_REPORT: "/reports/feedback",

	KPI_DASHBOARD: "/kpi-dashboard",
	REPORT_BUILDER: "/report-builder",
	PUBLIC_REPORT: "/shared/report/:shareId",

	SETTINGS: "/settings",
	SETTINGS_SERVICES: "services-competences",
	SETTINGS_ECONOMY: "economy",
	SETTINGS_ORG: "org-settings",
	SETTINGS_NOTIFICATIONS: "notifications",
	SETTINGS_NOTIFICATIONS_HIDDEN: "notifications-hidden",
	SETTINGS_RECRUITMENT: "recruitment",
	SETTINGS_INTEGRATIONS: "integrations",
	SETTINGS_LIST_FILTERS: "list-filters",
	SETTINGS_SUBSIDIARIES: "subsidiaries",

	NOTIF_LOGS: "/notification-logs",
	API_LOGS: "/http-logs",
	REPSONSE_TIME_STATS: "/response-time-stats",
	SSE_TEST: "/sse-test",
	COMPONENT_SHOWCASE: "/component-showcase",

	LOGOUT: "/logout",
};
